'use client';

import { useEffect } from 'react';
import { useSearchParams } from 'next/navigation';
import { detectReferralSource, storeReferralData } from '@/lib/referral-tracking';

export function ReferralTracker() {
  const searchParams = useSearchParams();

  useEffect(() => {
    // Only capture on initial page load (not on navigation)
    if (typeof window !== 'undefined' && !sessionStorage.getItem('alli_referral_captured')) {
      const referrer = document.referrer;
      // Path + query only; drop the fragment. Referral tracking
      // never uses fragments, and some flows (e.g. /mfa/recover)
      // put security credentials there — capturing them would leak
      // via any downstream code that sends landingPage to the server.
      const currentUrl =
        window.location.origin +
        window.location.pathname +
        window.location.search;

      // Convert searchParams to URLSearchParams
      const urlSearchParams = new URLSearchParams(searchParams.toString());

      // Detect and store referral data
      const referralData = detectReferralSource(urlSearchParams, referrer, currentUrl);

      console.log('[ReferralTracker] Captured referral data:', {
        source: referralData.referralSource,
        isPaid: referralData.isPaidReferrer,
        referrer: referrer || 'direct',
        landingPage: currentUrl
      });

      // Store the data
      storeReferralData(referralData);

      // Mark as captured to avoid re-capturing on navigation
      sessionStorage.setItem('alli_referral_captured', 'true');
    }
  }, [searchParams]);

  return null; // This component doesn't render anything
}